import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';

export default class KeyboardKey extends Phaser.GameObjects.Container {
  constructor(scene, key) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.name;
    this.shuffledX;
    this.shuffledY;
    this.startX;
    this.startY;
    this.altStartX = null;
    this.altStartY = null;
    this.companion = null;
    this.isPlaced = false;
    this.isTweening = false;

    this.keyImg = ABCyaPhaser.Images.addImage(0, 0, key, this);

    this.setSize(this.keyImg.width, this.keyImg.height);
    this.shape = new Phaser.Geom.Rectangle(-this.keyImg.width / 2, -this.keyImg.height / 2, this.keyImg.width, this.keyImg.height);

    // ////ADD DRAG AND DROP INPUTS//////

    this.on('dragstart', (pointer, gameObject) => {
      // console.log("drag start");
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.parentContainer.bringToTop(this);
      this.scene.tweens.killTweensOf(this);

      this.parentContainer.disableKeys();

      if (gameData.gameStyle === 'Classic') {
        ABCyaPhaser.Tweens.addTween(this, 250, { scaleX: 1.25, scaleY: 1.25 }, Phaser.Math.Easing.Bounce.Out);
      }
    });

    this.on('drag', (pointer, dragX, dragY) => {
      this.x = dragX;
      this.y = dragY;
    });

    this.on('dragend', (pointer, gameObject) => {
      const minX = this.startX - this.keyImg.width / 2;
      const minY = this.startY - this.keyImg.height / 2;
      const maxX = this.startX + this.keyImg.width / 2;
      const maxY = this.startY + this.keyImg.height / 2;

      if (this.companion !== null) {
        const dist = Phaser.Math.Distance.Between(this.companion.x, this.companion.y, this.x, this.y).toFixed(0);
        const altminX = this.altStartX - this.keyImg.width / 2;
        const altminY = this.altStartY - this.keyImg.height / 2;
        const altmaxX = this.altStartX + this.keyImg.width / 2;
        const altmaxY = this.altStartY + this.keyImg.height / 2;

        if (this.x >= minX && this.x <= maxX && this.y <= maxY && this.y >= minY && dist > 100) {
          // proper key placement
          this.isPlaced = true;
          this.scene.updateTries(true);

          if (gameData.gameStyle === 'Classic') {
            ABCyaPhaser.Audio.playOneShot('correct_classic', this.scene);
            ABCyaPhaser.Tweens.addTween(
              this,
              400,
              { x: this.startX, y: this.startY, scaleX: 1, scaleY: 1 },
              Phaser.Math.Easing.Bounce.Out,
              () => {this.parentContainer.enableKeys();}
            );
          }
          else {
            ABCyaPhaser.Tweens.addTween(
              this,
              200,
              { x: this.startX, y: this.startY },
              Phaser.Math.Easing.Back.Out,
              () => {
                this.parentContainer.enableKeys();

                if (gameData.gameStyle === 'Wood') {
                  this.smoke();
                  ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._correct_wood, this.scene);
                }
                else if (gameData.gameStyle === 'SciFi') {
                  this.edgeParticles();
                  ABCyaPhaser.Audio.playOneShot('correct_scifi', this.scene);
                }
                else if (gameData.gameStyle === 'Slime') {
                  this.slimeBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_slime', this.scene);
                }
                else if (gameData.gameStyle === 'Lava') {
                  this.lavaBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_lava', this.scene);
                }
                else if (gameData.gameStyle === 'Rnbow') {
                  this.rainbowBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_rainbow', this.scene);
                }
              }
            );
          }
        }
        else if (this.x >= altminX && this.x <= altmaxX && this.y <= altmaxY && this.y >= altminY && dist > 100) {
          // proper duplicate key placement
          this.isPlaced = true;

          this.scene.updateTries(true);

          if (gameData.gameStyle === 'Classic') {
            ABCyaPhaser.Audio.playOneShot('correct_classic', this.scene);
            ABCyaPhaser.Tweens.addTween(
              this,
              400,
              { x: this.altStartX, y: this.altStartY, scaleX: 1, scaleY: 1 },
              Phaser.Math.Easing.Bounce.Out,
              () => {this.parentContainer.enableKeys();}
            );
          }
          else {
            ABCyaPhaser.Tweens.addTween(
              this,
              200,
              { x: this.altStartX, y: this.altStartY },
              Phaser.Math.Easing.Back.Out,
              () => {
                this.parentContainer.enableKeys();

                if (gameData.gameStyle === 'Wood') {
                  this.smoke();
                  ABCyaPhaser.Audio.playOneShot('correct_wood', this.scene);
                }
                else if (gameData.gameStyle === 'SciFi') {
                  this.edgeParticles();
                  ABCyaPhaser.Audio.playOneShot('correct_scifi', this.scene);
                }
                else if (gameData.gameStyle === 'Slime') {
                  this.slimeBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_slime', this.scene);
                }
                else if (gameData.gameStyle === 'Lava') {
                  this.lavaBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_lava', this.scene);
                }
                else if (gameData.gameStyle === 'Rnbow') {
                  this.rainbowBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_rainbow', this.scene);
                }
              }
            );
          }
        }
        else {
          // not on correct key
          this.scene.updateTries();

          ABCyaPhaser.Audio.playOneShot('incorrect_answer', this.scene);
          ABCyaPhaser.Audio.playOneShot('tween', this.scene);

          ABCyaPhaser.Tweens.addTween(
            this,
            300,
            { x: this.shuffledX, y: this.shuffledY, scaleX: 1, scaleY: 1 },
            Phaser.Math.Easing.Back.Out,
            () => {this.parentContainer.enableKeys();}
          );
        }
      }
      else {
        if (this.x >= minX && this.x <= maxX && this.y <= maxY && this.y >= minY) {
          // proper key placement
          this.isPlaced = true;

          this.scene.updateTries(true);

          if (gameData.gameStyle === 'Classic') {
            ABCyaPhaser.Audio.playOneShot('correct_classic', this.scene);
            ABCyaPhaser.Tweens.addTween(
              this,
              400,
              { x: this.startX, y: this.startY, scaleX: 1, scaleY: 1 },
              Phaser.Math.Easing.Bounce.Out,
              () => {this.parentContainer.enableKeys();}
            );
          }
          else {
            ABCyaPhaser.Tweens.addTween(
              this,
              200,
              { x: this.startX, y: this.startY },
              Phaser.Math.Easing.Back.Out,
              () => {
                this.parentContainer.enableKeys();

                if (gameData.gameStyle === 'Wood') {
                  this.smoke();
                  ABCyaPhaser.Audio.playOneShot('correct_wood', this.scene);
                }
                else if (gameData.gameStyle === 'SciFi') {
                  this.edgeParticles();
                  ABCyaPhaser.Audio.playOneShot('correct_scifi', this.scene);
                }
                else if (gameData.gameStyle === 'Slime') {
                  this.slimeBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_slime', this.scene);
                }
                else if (gameData.gameStyle === 'Lava') {
                  this.lavaBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_lava', this.scene);
                }
                else if (gameData.gameStyle === 'Rnbow') {
                  this.rainbowBurst();
                  ABCyaPhaser.Audio.playOneShot('correct_rainbow', this.scene);
                }
              }
            );
          }
        }
        else {
          // not on correct key
          this.scene.updateTries();

          ABCyaPhaser.Audio.playOneShot('incorrect_answer', this.scene);
          ABCyaPhaser.Audio.playOneShot('tween', this.scene);

          ABCyaPhaser.Tweens.addTween(
            this,
            300,
            { x: this.shuffledX, y: this.shuffledY, scaleX: 1, scaleY: 1 },
            Phaser.Math.Easing.Back.Out,
            () => {this.parentContainer.enableKeys();}
          );
        }
      }
    });
  }

  setStartPos(x, y) {
    this.startX = x;
    this.startY = y;
  }

  setAltPos(x, y, companion) {
    this.altStartX = x;
    this.altStartY = y;
    this.companion = companion;
  }

  enableKey() {
    if (this.isPlaced === false) {
      this.setInteractive();
      this.scene.input.setDraggable(this);
    }
  }

  disableKey() {
    this.disableInteractive();
  }

  createKeyboardBezier(delayInd) {
    this.bezierGraphics = this.scene.add.graphics();

    this.path = new Phaser.Curves.Path(this.x + this.parentContainer.x, this.y + this.parentContainer.y);

    this.path.cubicBezierTo(
      new Phaser.Math.Vector2(200, 200), // start point
      new Phaser.Math.Vector2(600, 0), // control point1
      new Phaser.Math.Vector2(this.scene.mid.x + 125, this.scene.mid.y - 180)
    );// end point

    this.path.ellipseTo(150);

    this.path.cubicBezierTo(
      new Phaser.Math.Vector2(700, 400), // start point
      new Phaser.Math.Vector2(100, 600), // control point1
      new Phaser.Math.Vector2(this.shuffledX + this.parentContainer.x, this.shuffledY + this.parentContainer.y)
    );// end point


    // this.bezierGraphics.clear();
    // this.bezierGraphics.lineStyle(2, 0xffffff, 1);
    // this.path.draw(this.bezierGraphics);

    const tweenObject = { val: 0 };
    this.scene.tweens.add({
      targets: tweenObject,
      val: 1,
      duration: 2000,
      delay: 100 * delayInd,
      ease: Phaser.Math.Easing.None,
      callbackScope: this,
      onUpdate: (tween, target) => {
        const position = this.path.getPoint(target.val);
        this.x = position.x - this.parentContainer.x;
        this.y = position.y - this.parentContainer.y;
      },
      onComplete: () => {this.enableKey();}
    });
  }

  smoke() {
    // console.log("bursting!", gameData.level);
    const key = 'dustParticle1';

    const config = {
      key: 'burst',
      frames: this.scene.anims.generateFrameNames(gameData.particleAtlas, { start: 1, end: 5, prefix: 'dustParticle' }),
      frameRate: Phaser.Math.Between(6, 12)
    };
    gameData.anim = this.scene.anims.create(config);

    this.particles = this.scene.add.particles(gameData.particleAtlas);

    const emitter = this.particles.createEmitter({
      x: 0,
      y: 0,
      frame: key,
      speed: { min: -180, max: 250 },
      rotate: { min: -180, max: 180 },
      scale: { start: 1, end: 0 },
      alpha: { start: .25, end: 0 },
      lifespan: 400,
      quantity: 25,
      maxParticles: 75,
      particleClass: AnimatedParticle,
      emitZone: { source: this.shape }
    });

    this.addAt(emitter.manager, 0);
  }

  edgeParticles() {
    // console.log("edgy!", this.keyImg.width);
    let newScale;
    let newQuantity;
    let newDelay;

    if (this.keyImg.width < 75) {
      newScale = .25;
      newQuantity = 40;
      newDelay = 710;
    }
    else if (this.keyImg.width >= 75 && this.keyImg.width <= 150) {
      newScale = .35;
      newQuantity = 65;
      newDelay = 1150;
    }
    else {
      newScale = .5;
      newQuantity = 85;
      newDelay = 1450;
    }

    this.particles = this.scene.add.particles(gameData.particleAtlas);

    const emitter = this.particles.createEmitter({
      frame: 'blueBurst',
      scale: { start: newScale, end: 0 },
      alpha: { start: .5, end: 0 },
      blendMode: 'ADD',
      emitZone: { type: 'edge', source: this.shape, quantity: newQuantity }
    });

    this.add(emitter.manager);
    this.scene.time.delayedCall(newDelay, () => {this.particles.destroy();});
  }

  lavaBurst() {
    // console.log("flickering", this.x, this.y);
    let randAmount;
    if (this.keyImg.width < 75) {
      randAmount = 50;
    }
    else if (this.keyImg.width >= 75 && this.keyImg.width <= 150) {
      randAmount = 100;
    }
    else {
      randAmount = 150;
    }

    const emitter = this.scene.add.particles(gameData.particleAtlas, 'yellowBurst').createEmitter({
      speed: { min: -400, max: 400 },
      scale: { start: Phaser.Math.FloatBetween(.75, 2), end: 0 },
      blendMode: 'SCREEN',// {'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: Phaser.Math.Between(400, 1000),
      gravityY: 300,
      alpha: { min: 0, max: 1 },
      quantity: randAmount,
      maxParticles: randAmount,
      emitZone: { source: this.shape }
    });

    this.addAt(emitter.manager, 0);
  }

  slimeBurst() {
    // console.log("flickering", this.x, this.y);
    let randAmount;
    if (this.keyImg.width < 75) {
      randAmount = 100;
    }
    else if (this.keyImg.width >= 75 && this.keyImg.width <= 150) {
      randAmount = 150;
    }
    else {
      randAmount = 200;
    }

    const emitter = this.scene.add.particles(gameData.particleAtlas).createEmitter({
      frame: ['Slime_Splt', 'Slime_Splt1', 'Slime_Splt2', 'Slime_Splt3', 'Slime_Splt4'],
      speedX: { min: -200, max: 200 },
      speedY: { min: -400, max: 0 },
      scale: { start: Phaser.Math.FloatBetween(.75, 2), end: Phaser.Math.FloatBetween(.25, 0) },
      blendMode: 'OVERLAY',// {'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: { min: 500, max: 700 },
      gravityY: 900,

      // alpha: { start: 1, end: Phaser.Math.FloatBetween(.5, 0) },
      quantity: randAmount,
      maxParticles: randAmount,
      emitZone: { source: this.shape }
    });

    this.addAt(emitter.manager, 0);
  }

  rainbowBurst() {
    // console.log("flickering", this.x, this.y);
    const burst = ABCyaPhaser.Images.addImage(0, 0, 'rainbowBurst', this);

    this.moveDown(burst);
    burst.setScale(0, 0);

    let newX;
    if (this.keyImg.width < 75) {
      newX = 1;
    }
    else if (this.keyImg.width >= 75 && this.keyImg.width <= 150) {
      newX = 1.5;
    }
    else {
      newX = 3;
    }

    ABCyaPhaser.Tweens.addTween(burst, 750, { scaleX: newX, scaleY: 1, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }
}

class AnimatedParticle extends Phaser.GameObjects.Particles.Particle {
  constructor (emitter) {
    super(emitter);

    this.t = 0;
    this.i = 0;
  }

  update (delta, step, processors) {
    const result = super.update(delta, step, processors);

    this.t += delta;

    if (this.t >= gameData.anim.msPerFrame) {
      this.i++;

      if (this.i > gameData.anim.frames.length - 1) {
        if (gameData.anim.repeat === -1) {
          this.i = 0;
        }
        else {
          return;
        }
      }

      this.frame = gameData.anim.frames[this.i].frame;

      this.t -= gameData.anim.msPerFrame;
    }

    return result;
  }
}